<template>
  <section class="organism-hero-section">
    <div class="hero-wrapper">
      <div class="hero-content">
        <h1 class="hero-title">
          Your drone jobs, live and interactive for clients and teams
        </h1>
        <p class="hero-subheading">
          Run live jobs, talk with clients, and deliver results with absolute
          clarity.
        </p>
        <div class="hero-cta-buttons">
          <Button
            variant="primary"
            text="Get Free Trial"
            @click="openCalendly"
            class="hero-demo-button"
          />
        </div>
      </div>
      <div class="hero-illustration">
        <img
          src="@/assets/main-banner.png"
          alt="Hero illustration"
          class="hero-banner"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Button from "@/components/atoms/Button.vue";

export default {
  name: "HeroSection",
  components: {
    Button,
  },
  methods: {
    openCalendly() {
      window.open(
        "https://cal.com/skyhost/30min",
        "_blank",
        "noopener,noreferrer"
      );
    },
  },
};
</script>

<style scoped>
.organism-hero-section {
  position: relative;
  height: 100vh;
  padding: 20px;
  background-color: #000;
  overflow: visible;
}

.hero-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  gap: clamp(1rem, 2vh, 2rem);
}

.hero-content {
  max-width: 1000px;
  position: relative;
  z-index: 2;
  margin-top: clamp(4vh, 10vh, 10vh);
  margin-bottom: 0;
  text-align: center;
  width: 100%;
  flex-shrink: 0;
}

.hero-title {
  font-size: clamp(3rem, 5vw, 4.5rem);
  font-weight: 300;
  color: white;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.hero-subheading {
  font-size: 1.25rem;
  font-weight: 300;
  color: #bebebe;
  margin-bottom: 2.5rem;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.hero-cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 1rem;
}

.hero-demo-button {
  font-weight: 600;
  background-color: #fff !important;
  color: #000 !important;
  border: none !important;
  padding: 20px 40px;
  border-radius: 30px;
}

.hero-demo-button:hover {
  background-color: #f5f5f5 !important;
}

.hero-note {
  font-size: 0.9rem;
  color: #888;
  margin-top: 0.5rem;
}

.hero-illustration {
  position: relative;
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1;
  pointer-events: none;
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
}

.hero-banner {
  width: 100%;
  max-width: 1000px;
  max-height: 60vh;
  height: auto;
  object-fit: contain;
}

@media (max-width: 1200px) {
  .hero-content {
    margin-top: clamp(3vh, 8vh, 8vh);
  }

  .hero-title {
    font-size: clamp(2.5rem, 4vw, 3.5rem);
  }

  .hero-wrapper {
    gap: clamp(0.75rem, 1.5vh, 1.5rem);
  }

  .hero-banner {
    max-height: 55vh;
  }
}

@media (max-width: 768px) {
  .organism-hero-section {
    padding: 10px;
    height: auto;
    min-height: 100vh;
    overflow: hidden;
  }

  .hero-wrapper {
    padding: 15px;
    min-height: 100vh;
    gap: clamp(1rem, 2vh, 2rem);
  }

  .hero-content {
    margin-top: clamp(5vh, 12vh, 12vh);
    position: relative;
    flex-shrink: 0;
  }

  .hero-title {
    font-size: clamp(2.25rem, 8vw, 3rem);
    font-weight: 400;
    padding: 0 0.5rem;
    margin-bottom: 1.5rem;
    line-height: 1.15;
    letter-spacing: -0.03em;
  }

  .hero-subheading {
    font-size: 1.15rem;
    font-weight: 300;
    padding: 0 0.5rem;
    margin-bottom: 2.5rem;
    line-height: 1.5;
    color: #d0d0d0;
  }

  .hero-cta-buttons {
    flex-direction: column;
    width: 100%;
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .hero-cta-buttons .atom-button {
    width: 100%;
  }

  .hero-demo-button {
    padding: 18px 36px !important;
    font-size: 1.05rem !important;
    font-weight: 600 !important;
  }

  .hero-note {
    font-size: 0.9rem;
  }

  .hero-illustration {
    position: relative;
    width: 100%;
    padding: 0 0.5rem;
    pointer-events: auto;
    flex-grow: 0;
  }

  .hero-banner {
    max-width: 100%;
    width: 100%;
    max-height: 45vh;
    padding: 0;
    height: auto;
    border-radius: 8px;
  }
}
</style>
